export default __webpack_public_path__ + "media/images/icons/icon-pause-90de171ea46c3e1a5da62968e1017700.svg";